export default __webpack_public_path__ + "static/media/wallet.76bc6c43.svg";